import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './ProductErrorPanel.scss';

const ProductErrorPanel = props => {
  return (
    <div className='product-error-panel-container'>
      <div className='header-container'>
        <div className='header'>{props.message || 'There was an issue'}</div>
        <div className='subheader'>We were unable to load this product. Please click below to try again.</div>
      </div>
      <div className='actions'>
        <Link to='/shop/discover/categories' className='action secondary'>
          Shop Categories
        </Link>
        <div className='action primary' onClick={props.retry}>
          Try again
        </div>
      </div>
    </div>
  );
};

ProductErrorPanel.propTypes = {
  retry: PropTypes.func.isRequired,
  message: PropTypes.string
};

export default ProductErrorPanel;
